import * as React from "react";
import MUIDialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Button } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import { size } from "lodash";
import styles from "../shared/scroll.module.css";
import ConfirmDialog from "../custom-dialog/confirm-dialog";
import { useBoolean } from "../../hooks/use-boolean";

/**
 * Custom Dialog
 * @param {function} handleClose - close dialog
 * @param {boolean} open - manages visibility of dialog
 * @param {string} title - title in dialog format
 */
export default function Dialog({
  handleClose,
  viewMode = false,
  open,
  title,
  children,
  fullWidth,
  maxWidth,
}) {
  const confirm = useBoolean();
  const handleClosee = (event, reason) => {
    if (viewMode === true && reason === "escapeKeyDown") {
      confirm.onTrue();
      return;
    }
    if (reason && reason === "backdropClick") return;
    handleClose();
  };

  return (
    <>
      <MUIDialog
        sx={{
          "& .MuiDialog-paper":{
            borderRadius: "12px",
          }
        }}
        disableEnforceFocus
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClosee}
      >
        {!!size(title) ? <DialogTitle>{title}</DialogTitle> : null}
        <DialogContent className={styles.scrol}> {children}</DialogContent>
      </MUIDialog>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Close"
        content="Are you sure want to close?"
        cancelButtonName="No"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleClose();
              confirm.onFalse();
            }}
          >
            Yes
          </Button>
        }
      />
    </>
  );
}
